import { render, staticRenderFns } from "./PlayerPoints.vue?vue&type=template&id=6ab2e1d8&scoped=true&"
import script from "./PlayerPoints.vue?vue&type=script&lang=js&"
export * from "./PlayerPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab2e1d8",
  null
  
)

export default component.exports